import PropTypes from 'prop-types';
import React from 'react';
import { capitalize } from 'lodash';

import Order from '../../../records/Order';

import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import { translate as t } from '../../../lib/I18n';
import PureRenderComponent from '../../PureRenderComponent';
import Address from '../../customer/Address';
import ExternalLink from '../../general/ExternalLink';
import config from '../../../config';

class DeliveryInformationPostal extends PureRenderComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired
    };

    render () {
        const { order } = this.props;
        const { delivery } = order;

        return (
            <div>
                {order.isETicketByPostDelivery() && (
                    <p>
                        <FormattedHTMLMessage
                            message='order.details.postalDelivery.description'
                            here={
                                <ExternalLink
                                    message={ capitalize(t('global.clickHere')) }
                                    href={ config.get('eTicketsUrl') }
                                />
                            }
                        />
                    </p>
                )}
                <p>
                    <FormattedHTMLMessage
                        message='order.details.postalDelivery'
                        deliveryMethod={
                            <FormattedHTMLMessage
                                message={ delivery.displayName }
                                trademark={ <b>&#8482;</b> }
                            />
                        } />
                </p>
                <Address address={ delivery.getAddress() } className="margin-bottom--sm text-weight--normal" />
            </div>
        );
    }
}

export default DeliveryInformationPostal;
